var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-20.8%",
    y: "-16.7%",
    width: "141.7%",
    height: "141.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u269B-atoms/icons/24/close-btn",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F3F4F7",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u269B-atoms/icons/16/close/dark",
    transform: "translate(6.000000, 6.000000)",
    fill: "#364344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross-icn-dark",
    transform: "translate(0.750000, 0.750000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.61135276,0.276464426 L5.25,3.915 L8.88864724,0.276464426 C9.22891115,-0.063799483 9.76432542,-0.0899736299 10.1346125,0.197941986 L10.2235356,0.276464426 C10.5921548,0.645083662 10.5921548,1.24273353 10.2235356,1.61135276 L10.2235356,1.61135276 L6.585,5.25 L10.2235356,8.88864724 C10.5921548,9.25726647 10.5921548,9.85491634 10.2235356,10.2235356 C9.85491634,10.5921548 9.25726647,10.5921548 8.88864724,10.2235356 L5.25,6.585 L1.61135276,10.2235356 C1.27108885,10.5637995 0.735674584,10.5899736 0.365387542,10.302058 L0.276464426,10.2235356 C-0.0921548088,9.85491634 -0.0921548088,9.25726647 0.276464426,8.88864724 L0.276464426,8.88864724 L3.915,5.25 L0.276464426,1.61135276 C-0.0921548088,1.24273353 -0.0921548088,0.645083662 0.276464426,0.276464426 C0.645083662,-0.0921548088 1.24273353,-0.0921548088 1.61135276,0.276464426 Z",
    id: "Combined-Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.4cfd9c163baa9b5c3f8a620eee415ed8.svg";
export { ForwardRef as ReactComponent };